import { jsonFetch } from "../client/api/api"
import { debounce } from "../utils/timer"

let form = document.getElementById('leo_members_filters')
let search = document.getElementById('search_input')
let chbxCategories = document.querySelectorAll('.chbx-cat')
let chbxDomains = document.querySelectorAll('.chbx-domain')
let chbxUniversities = document.querySelectorAll('.chbx-university')
let container = document.getElementById('members_list')
let reset = document.querySelector('.reset')
let loading = false
let loader = document.getElementById('loading')

async function getMembers(){

    const categories = []
    const domains = []
    const universities = []

    container.classList.add('isLoading')

    chbxCategories.forEach((chbx) => {
        if (chbx.checked) {
            categories.push(chbx.value)
        }
    })

    chbxDomains.forEach((chbx) => {
        if (chbx.checked) {
            domains.push(chbx.value)
        }
    })

    chbxUniversities.forEach((chbx) => {
        if (chbx.checked) {
            universities.push(chbx.value)
        }
    })

    const params = new FormData()
    params.append('action', 'leo_search_members')
    params.append('search', search.value)

    if(categories.length > 0) {
        params.append('categories', categories)
    }

    if(domains.length > 0) {
        params.append('domains', domains)
    }

    if(universities.length > 0) {
        params.append('universities', universities)
    }

    const response = await jsonFetch(kreenoot_child.ajax_url, {
        method: 'POST',
        body: params,
    })

    if(response.success) {
        container.innerHTML = response.data
        container.classList.remove('isLoading')
    }
}

form?.addEventListener('change', getMembers)
search?.addEventListener('keyup', debounce(getMembers, 500))

reset?.addEventListener('click', function(){
    chbxCategories.forEach(c => {c.checked = false})
    chbxDomains.forEach(cd => {cd.checked = false})
    chbxUniversities.forEach(cu => {cu.checked = false})
    
    form.dispatchEvent(new Event('change'))
})


//Responsive Filters
let filtersBtn = document.querySelector('.filters-btn')

filtersBtn?.addEventListener('click', function(){
    document.querySelector('.publications-filters').classList.toggle('active')
})

let archiveFiltersBtn = document.querySelector('.archive-date-toggle');

archiveFiltersBtn?.addEventListener('click', function() {
    document.querySelector('.archive-date').classList.toggle('active');
    document.querySelector('.archive-date-toggle').classList.toggle('active');
});

